import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_SELFHARM_API_URL,
});

export const fetchSelfHarmOverview = async ({ startDate, endDate }) => {
  const res = await client.get('/api/selfharm/overview', {
    params: { startDate, endDate },
  });
  return res.data;
};

export const fetchSelfHarmUser = async (phone, { startDate, endDate }) => {
  const res = await client.get(
    `/api/selfharm/user/${encodeURIComponent(phone)}`,
    { params: { startDate, endDate } },
  );
  return res.data;
};

export const fetchSelfHarmAlerts = async ({ hoursBack }) => {
  const res = await client.get('/api/selfharm/alerts', {
    params: { hoursBack },
  });
  return res.data;
};

export const fetchSelfHarmTimeline = async ({ startDate, endDate }) => {
  const res = await client.get('/api/selfharm/risk-timeline', {
    params: { startDate, endDate },
  });
  return res.data;
};
